import { Checkbox, IconButton, Stack, Typography } from "@mui/material";
import { useStore } from "zustand";
import { formatSquareMeters, Icon } from "@designboticteam/react/components";
import { useEngineApi } from "@/engine";

const SelectedParcelsList = (): React.ReactNode => {
	const api = useEngineApi();
	const items = useStore(api.kolega3D.store, (state) => state.parcelSelection.items);

	if (items.length === 0) {
		return null;
	}

	return (
		<Stack direction="column" sx={{ gap: 0.5 }}>
			{items.map((item) => (
				<Stack key={item.id} direction="row" sx={{ alignItems: "center", gap: 1 }}>
					<Checkbox size="small" checked={true} onChange={() => api.kolega3D.parcels.removeSelected(item.id)} sx={{ padding: 0 }} />

					<Stack direction="column" sx={{ flex: 1, minWidth: 0 }}>
						<Typography variant="body2" sx={{ lineHeight: 1.2 }}>
							{item.numer}
						</Typography>
						<Typography variant="caption" color="textSecondary">
							{formatSquareMeters(item.areaM2)}
						</Typography>
					</Stack>

					<IconButton size="small" onClick={() => api.kolega3D.parcels.removeSelected(item.id)}>
						<Icon name="close" />
					</IconButton>
				</Stack>
			))}
		</Stack>
	);
};

export { SelectedParcelsList };
